import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { LoadingStyles } from "components/ui/LoadingStyles";
import { Spinner } from "components/ui/Spinner";
import { useAuthentication } from "components/hooks/useAuthentication";
import { useAPI } from "components/hooks/useAPI";

export function StatusAndProfileLoader({ children }) {
  const { loadState, url } = useAuthentication();
  const api = useAPI();

  useEffect(() => {
    window.clc = api;
  }, []);

  useEffect(() => {
    if (loadState === "failure" && url) {
      window.location = url;
    }
  }, [loadState, url]);

  if (["idle", "pending"].includes(loadState)) {
    return (
      <LoadingStyles>
        <Spinner />
      </LoadingStyles>
    );
  }

  if (loadState === "failure" && !url) {
    return (
      <LoadingStyles>
        There was a server error. Please try again later.
      </LoadingStyles>
    );
  }

  if (loadState === "success") {
    return children;
  }

  return null;
}

StatusAndProfileLoader.propTypes = {
  children: PropTypes.node,
};
